export default __webpack_public_path__ + "static/media/synamedia_logo.9575f024.svg";